var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "vue-need-bootstrap h100" },
    [
      _c(_setup.CLoader, {
        attrs: { value: _setup.isLoading, text: _setup.loaderText },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sign-up-page d-flex justify-content-center align-items-center w-100 h-100 gradient-customily-bg",
        },
        [
          _c("div", { staticClass: "card sign-up-card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("div", { staticClass: "text-center mb-4" }, [
                  _c("img", {
                    staticClass: "sign-up-logo",
                    attrs: { src: _setup.CustomilyImg, alt: "Customily" },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _setup.registered
                  ? _c("div", { staticClass: "text-center" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                    ])
                  : _c(_setup.ValidationObserver, {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ handleSubmit, valid }) {
                            return [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return handleSubmit(_setup.signUp)
                                    },
                                  },
                                },
                                [
                                  _c(_setup.ValidationProvider, {
                                    attrs: { rules: "required", name: "Name" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(_setup.CInput, {
                                                staticClass: "mb-3",
                                                attrs: {
                                                  type: "text",
                                                  label: "Name",
                                                  placeholder: "Type your name",
                                                  error: failed,
                                                  "error-msg": errors[0],
                                                },
                                                model: {
                                                  value: _setup.form.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _setup.form,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.name",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              content:
                                                "This field cannot be changed afterwards, it will be the ID in the affiliate link that you will share",
                                            },
                                            expression:
                                              "{\n                                    content:\n                                        'This field cannot be changed afterwards, it will be the ID in the affiliate link that you will share'\n                                }",
                                          },
                                        ],
                                        staticClass: "col-12 col-md-6",
                                      },
                                      [
                                        _c(_setup.ValidationProvider, {
                                          attrs: {
                                            rules: "required|alpha_num",
                                            name: "Username",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(_setup.CInput, {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        type: "text",
                                                        label: "Username",
                                                        placeholder:
                                                          "Type your username",
                                                        error: failed,
                                                        "error-msg": errors[0],
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.form.username,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _setup.form,
                                                            "username",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.username",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-md-6" },
                                      [
                                        _c(_setup.ValidationProvider, {
                                          attrs: {
                                            rules: "required|email",
                                            name: "Email",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(_setup.CInput, {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        type: "email",
                                                        label: "Email",
                                                        placeholder:
                                                          "Type your email",
                                                        error: failed,
                                                        "error-msg": errors[0],
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.form.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _setup.form,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.email",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-md-6" },
                                      [
                                        _c(_setup.ValidationProvider, {
                                          attrs: {
                                            rules: "required|min:8",
                                            name: "Password",
                                            vid: "password",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(_setup.CInput, {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        type: "password",
                                                        label: "Password",
                                                        placeholder:
                                                          "Type your password",
                                                        error: failed,
                                                        "error-msg": errors[0],
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.form.password,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _setup.form,
                                                            "password",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.password",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-md-6" },
                                      [
                                        _c(_setup.ValidationProvider, {
                                          attrs: {
                                            rules:
                                              "required|min:8|password-confirmed:password",
                                            name: "Password confirmation",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({
                                                  errors,
                                                  failed,
                                                }) {
                                                  return [
                                                    _c(_setup.CInput, {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        type: "password",
                                                        label:
                                                          "Confirm Password",
                                                        placeholder:
                                                          "Re-enter your password",
                                                        error: failed,
                                                        "error-msg": errors[0],
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.form
                                                            .passwordConfirmation,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _setup.form,
                                                            "passwordConfirmation",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.passwordConfirmation",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(_setup.ValidationProvider, {
                                    attrs: {
                                      rules: "required",
                                      name: "Captcha",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(_setup.CRecaptcha, {
                                                ref: "recaptcha",
                                                staticClass: "mb-3",
                                                attrs: {
                                                  error: failed,
                                                  "error-msg": errors[0],
                                                },
                                                model: {
                                                  value:
                                                    _setup.form.captchaToken,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _setup.form,
                                                      "captchaToken",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.captchaToken",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _setup.errorMessage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "error-message w-100 pb-3 text-center",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_setup.errorMessage) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(_setup.CButton, {
                                    staticClass: "w-100",
                                    attrs: {
                                      variant: "primary",
                                      type: "submit",
                                      text: "Sign Up",
                                      disabled: !valid || _setup.isLoading,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h5", { staticClass: "mt-2 mb-0" }, [
      _c("b", [
        _vm._v("Register your new account to join our Affiliate's Program!"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h4", { staticClass: "mb-3" }, [_c("b", [_vm._v("Thank you!")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "mb-0" }, [
      _vm._v(
        "\n                        Thanks for registering to Customily's Affiliate Program. Log in to your new account\n                        "
      ),
      _c("a", { attrs: { href: "/signin" } }, [_vm._v("here")]),
      _vm._v(
        " to find your affiliate link and see your dashboard.\n                    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }